interface OrgPermission {
  organizationId: number | null;
  permission: string;
}

interface AttributeRole {
  attributeId: number | null;
  role: { permissions: string[] };
}

interface RoleGroup {
  roles: { role: string }[];
}

export interface RoleBearingUser {
  globalRoles?: RoleGroup[];
  attributeRoles?: RoleGroup[];
}

class AuthStore {
  organizationPermissions: OrgPermission[] = [];
  roles: string[] = [];

  hasPermission(permission: string, organizationId?: number | null): boolean {
    if (organizationId === undefined) {
      return this.organizationPermissions.some(({ permission: p }) => p === permission);
    }

    return this.organizationPermissions.some(({ organizationId: o, permission: p }) => p === permission && (o === organizationId || o === null));
  }

  hasGlobalPermission(p: string): boolean {
    return this.hasPermission(p, null);
  }

  hasRole(role: string): boolean {
    return this.roles.includes(role);
  }

  set attributeRoles(attributeRoles: AttributeRole[]) {
    this.organizationPermissions = attributeRoles.flatMap((org) => org.role.permissions.map((permission) => ({ organizationId: org.attributeId, permission })));
  }

  setUserRoles(user: RoleBearingUser): void {
    const globalRoles = (user.globalRoles ?? []).flatMap((gr) => gr.roles.map((r) => r.role));
    const attrRoles = (user.attributeRoles ?? []).flatMap((ar) => ar.roles.map((r) => r.role));
    this.roles = [...new Set([...globalRoles, ...attrRoles])];
  }

  get authToken(): string | null {
    return getCookie('nnmp-token');
  }
}

const authStore = new AuthStore();

export function getCookie(name: string): string | null {
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
}

export default authStore;
